import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      transform: translate3d(100%, 0, 0);\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  ", "\n\n  opacity: ", ";\n  transition: opacity ", ";\n  z-index: ", ";\n\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        transform: translate3d(-100%, 0, 0);\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  @media screen and ", " {\n    background-color: inherit;\n    height: 100%;\n    max-width: ", ";\n    min-width: ", ";\n    position: fixed;\n    transition: ", ";\n    width: ", "%;\n    z-index: ", ";\n\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import styled, { css } from 'styled-components';
import { rgba, position } from 'polished';
import { useMediaQuery } from 'react-responsive';
import { mediaQueryTabletMax } from '@scp/ui-shared/theme/responsive';
import { property, zIndex } from '@scp/ui-shared/theme/variables';
import { sideNavigationHolderBase } from './baseStyles';
import { RESPONSIVE_NAV_SIZE } from './constants';
var SideNavigationHolder = styled.div(_templateObject(), sideNavigationHolderBase);
var ResponsiveNavigationHolder = styled.div(_templateObject2(), mediaQueryTabletMax, RESPONSIVE_NAV_SIZE.MAX_WIDTH, RESPONSIVE_NAV_SIZE.MIN_WIDTH, property.transition, RESPONSIVE_NAV_SIZE.WIDTH_PERCENTAGE, zIndex.popover, function (props) {
  return !props.$visible && css(_templateObject3());
});
var Overlay = styled.div(_templateObject4(), rgba('#000', 0.25), position('fixed', '0'), function (props) {
  return props.$visible ? 1 : 0;
}, property.transitionEasing, zIndex.modalOverlay, function (props) {
  return !props.$visible && css(_templateObject5());
});
export var SideNavigationHolderResponsive = function SideNavigationHolderResponsive(_ref) {
  var children = _ref.children,
      onToggle = _ref.onToggle,
      isOpen = _ref.isOpen;
  var isTablet = useMediaQuery({
    query: mediaQueryTabletMax
  });
  var escFunction = useCallback(function (event) {
    if (event.key === 'Escape' && isOpen) {
      !!onToggle && onToggle();
      event.preventDefault();
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [isOpen]);
  useEffect(function () {
    document.addEventListener('keydown', escFunction);
    return function () {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  if (isTablet) {
    return React.createElement(React.Fragment, null, React.createElement(Overlay, {
      onClick: onToggle,
      "$visible": isOpen
    }), React.createElement(FocusLock, {
      disabled: !isOpen || !isTablet
    }, React.createElement(ResponsiveNavigationHolder, {
      "$visible": isOpen
    }, children)));
  }

  return React.createElement(SideNavigationHolder, null, children);
};